import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { indexMap } from '@helpers'
import LinkItem from './LinkItem'
import './PrimaryNavigation.module.scss'

const PrimaryNavigation = ({ links, allowSubmenu }) => (
  <nav>
    <ul styleName='list'>
      {
        <Fragment>
          {indexMap(
            (item, index) => (
              <LinkItem index={index} item={item} allowSubmenu={allowSubmenu} key={`link-${index}`} />
            ),
            links
          )}
        </Fragment>
      }
    </ul>
  </nav>
)

PrimaryNavigation.propTypes = {
  links: PropTypes.arrayOf(PropTypes.string),
  allowSubmenu: PropTypes.bool
}

PrimaryNavigation.defaultProps = {
  links: [],
  allowSubmenu: false
}

export default PrimaryNavigation



// WEBPACK FOOTER //
// ./src/components/PrimaryNavigation/PrimaryNavigation.js